import { render, staticRenderFns } from "./ContactsList.vue?vue&type=template&id=be742f0a&scoped=true"
import script from "./ContactsList.vue?vue&type=script&lang=js"
export * from "./ContactsList.vue?vue&type=script&lang=js"
import style0 from "./ContactsList.vue?vue&type=style&index=0&id=be742f0a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be742f0a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2718431902/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be742f0a')) {
      api.createRecord('be742f0a', component.options)
    } else {
      api.reload('be742f0a', component.options)
    }
    module.hot.accept("./ContactsList.vue?vue&type=template&id=be742f0a&scoped=true", function () {
      api.rerender('be742f0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/lists/ContactsList.vue"
export default component.exports